<template>
  <validation-observer tag="div" v-slot="{ handleSubmit, invalid }" class="form__validation">
    <form class="form" slot="content" @submit.prevent="handleSubmit(onSubmit)">
      <div class="form__content">
        <CustomInput
          :disabled="isLoading"
          label="Nombre:"
          placeholder="Nombre del Subfactor"
          rules="required"
          v-model="name"
        />
        <Textarea
          :disabled="isLoading"
          label="Descripción:"
          placeholder="Descripción del Subfactor"
          rules="required"
          v-model="description"
        />
      </div>

      <div class="modal__buttons">
        <Button :disabled="isLoading || invalid" type="submit" size="small" variant="primary">
          Crear Subfactor
        </Button>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

import { mapActions } from 'vuex';

import Button from '@/components/buttons/Button.vue';
import CustomInput from '@/components/custom/CustomInput.vue';
import Textarea from '@/components/custom/Textarea.vue';

export default {
  components: {
    Button,
    CustomInput,
    Textarea,
    ValidationObserver,
  },

  props: {
    factorId: String,
  },

  data: () => ({
    name: '',
    description: '',
    isLoading: false,
  }),

  watch: {},

  methods: {
    ...mapActions('jobEvaluationProcess', ['addSubfactor']),

    async onSubmit() {
      this.isLoading = true;

      try {
        await this.addSubfactor({
          factorId: this.factorId,
          name: this.name,
          description: this.description,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
        this.$emit('back');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .form__content {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding-top: 0.2rem;
    padding-bottom: 1rem;
  }
}

.button {
  width: 100%;
}
</style>
